import React, { SVGProps } from "react";

const HouseFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z" />
  </svg>
);

const MailboxFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M104,152a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H96A8,8,0,0,1,104,152ZM168,32h24a8,8,0,0,0,0-16H160a8,8,0,0,0-8,8V56h16Zm72,84v60a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V192H32a16,16,0,0,1-16-16V116A60.07,60.07,0,0,1,76,56h76v88a8,8,0,0,0,16,0V56h12A60.07,60.07,0,0,1,240,116Zm-120,0a44,44,0,0,0-88,0v60h88Z" />
  </svg>
);

const PackageFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.35,44L178.57,92.29l-80.35-44Zm0,88L47.65,76,81.56,57.43l80.35,44Zm88,55.85h0l-80,43.79V133.83l32-17.51V152a8,8,0,0,0,16,0V107.56l32-17.51v85.76Z" />
  </svg>
);

const TruckFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M28,48H164a12,12,0,0,1,12,12V160H16V60A12,12,0,0,1,28,48Z" />
    <path d="M192,80h26.58a16,16,0,0,1,14.86,10l13.42,33.56a8,8,0,0,1,.57,3V152a8,8,0,0,1-8,8H192Z" />
    <circle cx="72" cy="188" r="20" />
    <circle cx="196" cy="188" r="20" />
  </svg>
);

const CurrencyFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm12,152h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24a28,28,0,0,1,0,56Z" />
  </svg>
);

const ClientsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 30 30"
    {...props}
  >
    <g fillRule="evenodd">
      <path d="M16 28v-6.508c1.796-.294 3.445-1.36 4.808-2.818a9.845 9.845 0 0 1 4.977 4.323l1.984 3.511a1 1 0 0 1-.87 1.492H16zm-2 0H3.1a1 1 0 0 1-.87-1.492l1.984-3.51a9.845 9.845 0 0 1 4.977-4.324c1.363 1.459 3.013 2.524 4.809 2.818V28zm1-9.175c-3.866 0-7-5.632-7-9.614C8 5.228 11.134 2 15 2s7 3.228 7 7.21c0 3.983-3.134 9.615-7 9.615z" />
    </g>
  </svg>
);

const HeadsetFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M232,128v80a40,40,0,0,1-40,40H136a8,8,0,0,1,0-16h56a24,24,0,0,0,24-24H192a24,24,0,0,1-24-24V144a24,24,0,0,1,24-24h23.65A88,88,0,0,0,66,65.54,87.29,87.29,0,0,0,40.36,120H64a24,24,0,0,1,24,24v40a24,24,0,0,1-24,24H48a24,24,0,0,1-24-24V128A104.11,104.11,0,0,1,201.89,54.66,103.41,103.41,0,0,1,232,128Z" />
  </svg>
);

const GearFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M216,130.16q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.29,107.29,0,0,0-26.25-10.86,8,8,0,0,0-7.06,1.48L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" />
  </svg>
);

const ToolsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={517}
    height={517}
    viewBox="0 0 517 517"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(0,517) scale(0.1,-0.1)" stroke="none">
      <path d="M1958 4690 c-125 -33 -175 -55 -190 -83 -6 -13 -10 -83 -9 -188 2 -201 -1 -211 -86 -253 -32 -17 -89 -50 -127 -74 -109 -69 -114 -69 -271 27 -151 92 -179 104 -218 87 -27 -11 -149 -124 -199 -185 -47 -56 -40 -85 58 -248 101 -167 101 -170 32 -279 -24 -38 -57 -95 -74 -127 -42 -85 -53 -88 -252 -87 -92 1 -175 -1 -184 -5 -31 -12 -56 -67 -88 -198 -31 -126 -32 -127 -13 -159 14 -23 55 -52 158 -109 77 -43 148 -88 158 -100 15 -18 17 -44 17 -189 0 -190 -3 -200 -82 -239 -24 -11 -86 -45 -138 -74 -75 -42 -99 -61 -113 -89 -17 -35 -17 -39 3 -120 37 -146 60 -208 86 -225 20 -13 54 -15 193 -14 109 1 177 -2 193 -10 16 -7 43 -43 73 -97 27 -48 61 -106 77 -130 54 -78 51 -92 -45 -254 -46 -78 -87 -152 -90 -163 -12 -40 28 -93 166 -222 81 -76 96 -75 272 32 94 57 149 85 170 85 18 0 51 -14 80 -33 28 -19 88 -54 133 -78 54 -28 89 -54 98 -71 10 -20 14 -71 14 -203 0 -175 0 -176 25 -199 25 -23 109 -52 238 -81 100 -23 112 -14 208 160 43 77 88 148 100 158 18 15 44 17 189 17 145 0 171 -2 189 -17 12 -10 57 -81 100 -158 98 -177 109 -185 214 -160 140 34 226 65 242 88 12 17 15 55 15 195 0 107 4 181 11 194 10 19 -5 37 -151 183l-163 163 -46 -14c-228 -71 -506 -78 -748 -19 -559 136 -970 575 -1079 1150 -26 138 -24 369 6 515 111 556 515 984 1053 1120 405 102 807 34 1152 -196 193 -128 330 -274 450 -479 184 -315 238 -708 146 -1066l-28 -108 162 -161c146 -146 164 -161 183 -151 13 7 87 11 195 11 172 0 175 0 199 25 25 25 52 104 83 238 24 105 18 112 -227 246 -43 23 -85 52 -93 64 -12 17 -15 56 -15 188 0 147 2 169 18 189 10 13 81 57 157 99 175 95 185 109 161 209 -35 140 -60 213 -82 237 -23 25 -24 25 -199 25 -213 0 -215 1 -269 106 -21 41 -49 90 -62 109 -44 65 -56 97 -50 127 3 16 42 89 85 161 80 132 84 142 82 185 -1 24 -84 119 -170 195 -78 68 -91 66 -267 -39 -163 -98 -177 -100 -256 -46 -24 16 -82 50 -129 76 -58 31 -90 55 -98 73 -8 18 -11 79 -10 192 1 108 -2 174 -9 187 -16 30 -64 50 -201 86 -119 31 -120 31 -152 12 -24 -14 -52 -55 -110 -159 -43 -77 -88 -148 -100 -157 -18 -16 -44 -18 -188 -18 -132 0 -171 3 -188 15 -12 8 -56 78 -98 156 -56 102 -85 146 -108 160 -39 23 -38 24 -169 -11z" />
      <path d="M2392 3530 c-85 -12 -102 -18 -102 -38 0 -9 129 -146 287 -303 158 -158 290 -296 294 -306 23 -56 -4 -126 -106 -283 -59 -90 -226 -260 -312 -318 -163 -110 -258 -142 -313 -105 -14 9 -147 137 -295 286 -149 148 -278 273 -287 278 -25 14 -36 -9 -49 -106 -29 -218 19 -440 140 -650 63 -109 235 -282 346 -347 206 -120 409 -163 653 -138 144 15 199 11 257 -15 27 -12 207 -184 550 -525 555 -551 554 -550 689 -573 133 -23 281 27 382 127 145 146 172 368 66 541 -13 22 -246 263 -517 535 -353 354 -501 509 -519 544 -30 57 -33 116 -14 287 20 179 -18 382 -102 549 -141 279 -401 481 -703 546 -89 19 -261 26 -345 14z" />
    </g>
  </svg>
);

const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8 6.667L3.333 2 2 3.333 6.667 8 2 12.667 3.333 14 8 9.333 12.667 14 14 12.667 9.333 8 14 3.333 12.667 2z"
    />
  </svg>
);

const SignOutFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40A8,8,0,0,0,176,88v32H112a8,8,0,0,0,0,16h64v32a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,229.66,122.34Z" />
  </svg>
);

const SquaresFourFillIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M120,56v48a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40h48A16,16,0,0,1,120,56Zm80-16H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm-96,96H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm96,0H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Z" />
  </svg>
);

export {
  HouseFillIcon,
  MailboxFillIcon,
  PackageFillIcon,
  TruckFillIcon,
  CurrencyFillIcon,
  ClientsIcon,
  HeadsetFillIcon,
  GearFillIcon,
  ToolsIcon,
  CloseIcon,
  SignOutFillIcon,
  SquaresFourFillIcon,
};
